import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import UI from "../../components/ExcerciseTypes/Design/UserInterface";
const json = {
  1: {
    unit: "Unit 1",
    id: "SB7-U1-P16-E3",
    audio: "Audios/p26_intro.mp3",
    autoPlay: true,
    // video: "",
    component: UI,
    // recorder: true,
    titleQuestion: [
      {
        num: "",
        title: `<img src="img/FriendsPlus/Page26/Demo/a.jpg" style="height:30mm;margin-top:-40px "/>`,
        color: "#cf2370",
        prefix: { icons: [] },
      },
    ],
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
    //     <span>Tra cứu</span>

    //     `,
    //   },
    // ],
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>
        Dùng e ke để xác định một góc là góc nhọn, góc tù hay góc bẹt.<br>
        Đặt đỉnh góc vuông của ê ke trùng với đỉnh O của góc sao cho một cạnh của ê ke trùng với 1 cạnh của góc.<br>
        - Quan sát cạnh thứ hai của góc ta nhận thấy: <br>
          + Góc nhọn đỉnh O, cạnh OA, OB, góc nhọn bé hơn góc vuông.<br>
          + Góc tù đỉnh O, cạnh ON, OM, góc tù lớn hơn góc vuông.<br>
          + Góc bẹt đỉnh O, cạnh OC, OD, góc bẹt bằng hai góc vuông.<br>

          <video src="Audios/guide/p26_e1.mp3" controls style="width: 100%; height: 2cm"></video>      
        </span>
        
        `,
      },
    ],
    questionImage: [
      [
        { url: "img/FriendsPlus/Page26/Demo/1.jpg" },
        {
          url: "img/FriendsPlus/Page26/Demo/2.jpg",
          audioUrl: "Audios/Đây là góc nhọn.mp3",
        },
        { url: "img/FriendsPlus/Page26/Demo/3.jpg" },
        {
          url: "img/FriendsPlus/Page26/Demo/4.jpg",
          audioUrl: "Audios/Đây là góc tù.mp3",
        },
        { url: "img/FriendsPlus/Page26/Demo/5.jpg" },
        {
          url: "img/FriendsPlus/Page26/Demo/6.jpg",
          audioUrl: "Audios/Đây là góc bẹt.mp3",
        },
        { url: "img/FriendsPlus/Page26/Demo/7.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page26/Demo/8.jpg" }],
    ],
  },

  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    video: "",
    exerciseKey: "/img/FriendsPlus/page26/key/E2answerKey.png",
    component: T6,
    isHiddenCheck: true,
    // protractor: true,
    // hideBtnFooter: true,
    // isEssay:true,
    // maxLength:3,
    stylesTextInput: {
      fontSize: 23,
      borderBottom: "dash",
      textAlign: "center",
    },
    inputSize: 150,
    textareaStyle: { width: 800 },
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
    //     <span>Đang cập nhật</span>

    //     `,
    //   },
    // ],
    // overflowY:'auto',
    // maxHeight:'18cm',

    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>- Xác định được loại góc (tù/nhọn/bẹt) trong mỗi hình. <br>
        - Lần lượt nháy chuột vào mỗi hình rồi di chuyển vào từng cột ghi tên loại góc thích hợp trong bảng bên dưới.
        <video src="Audios/guide/p26_e2.mp3" controls style="width: 100%; height: 2cm"></video>      
         </span>
        
        `,
      },
    ],

    dragAndDrop: [
      {
        decreaseLeft: 15,
        decreaseTop: 5,
        dragImage: true, // Nếu kếu thả hình ảnh thì thêm thuộc tính này vào (đáp án đúng hoặc sai sẽ hiển thị icon)
        defaultPostion: [
          // lấy vị trí left + top ban đầu của ảnh cần kéo thả (4 vị trí tương ứng 4 ảnh)

          {
            top: -24,
            left: 16,
          },
          {
            top: -5,
            left: 380,
          },
          {
            top: -5,
            left: 606,
          },
          {
            top: -10,
            left: 208,
          },
          {
            top: -5,
            left: 750,
          },
          {
            top: -5,
            left: 902,
          },
        ],
        answers: [
          {
            // image 1
            top: 153, // // lấy vị trí top của ảnh sau khi kéo thả
            left: 28, // lấy vị trí left của ảnh sau khi kéo thả
            minTop: 120,
            maxTop: 260,
            minLeft: -10,
            maxLeft: 230,
          },
          {
            // image 2
            top: 429, // // lấy vị trí top của ảnh sau khi kéo thả
            left: 368, // lấy vị trí left của ảnh sau khi kéo thả
            minTop: 182,
            maxTop: 293,
            minLeft: 369,
            maxLeft: 570,
          },
          {
            // image 3
            top: 435, // // lấy vị trí top của ảnh sau khi kéo thả
            left: -6, // lấy vị trí left của ảnh sau khi kéo thả
            minTop: -15,
            maxTop: 246,
            minLeft: -5,
            maxLeft: 1047,
          },
          {
            // image 4
            top: 364, // // lấy vị trí top của ảnh sau khi kéo thả
            left: 751, // lấy vị trí left của ảnh sau khi kéo thả
            minTop: 135,
            maxTop: 318,
            minLeft: 747,
            maxLeft: 979,
          },
          {
            // image 5
            top: 153, // // lấy vị trí top của ảnh sau khi kéo thả
            left: 28, // lấy vị trí left của ảnh sau khi kéo thả
            minTop: 120,
            maxTop: 295,
            minLeft: -10,
            maxLeft: 240,
          },
          {
            // image 6
            top: 429, // // lấy vị trí top của ảnh sau khi kéo thả
            left: 368, // lấy vị trí left của ảnh sau khi kéo thả
            minTop: 182,
            maxTop: 293,
            minLeft: 369,
            maxLeft: 570,
          },
        ],
      },
    ],

    titleQuestion: [
      {
        num: "",
        title: ` 
        <div style='display:flex'>
   			<div style="background-color: rgb(130,219,189); border-radius: 50%; color: white; width: 39px; height: 39px; text-align: center; line-height: 39px;margin-right:10px">
   			1
   			</div>
   			Tìm các góc nhọn, góc tù và góc bẹt trong các góc sau.</div>
        `,
        color: "rgb(130,219,189)",
        // star: 1
      },
    ],
    // recorder: true,
    hideBtnFooter: true,
    questionImage: [],
    questions: [
      {
        title: `
        <div id="drag" style="position: absolute; top: -24px; left: 16px; margin-top: 40px">
          <img
            src="/img/FriendsPlus/Page26/E2/1.png"
            alt=""
            width="170px"
            height="120px"
          />
          <div style="position: absolute;left: 94px;top:36px;">
            <img id='tick-image' src="img/FriendsPlus/page29/E3/tick-image.png" alt="image" width="40px" style='display: none;'/>
            <img id='error-image' src="img/FriendsPlus/page29/E3/error-image.png" alt="image" width="30px" style='display: none;'/>
          </div>
        </div>

        <div id="drag" style="position: absolute; top: -5px; left: 380px;">
          <img
          src="/img/FriendsPlus/Page26/E2/2.png"
            alt=""
            width="200px"
            height="120px"
          />
          <div style="position: absolute;left: 94px;top:67px;">
            <img id='tick-image' src="img/FriendsPlus/page29/E3/tick-image.png" alt="image" width="40px" style='display: none;'/>
            <img id='error-image' src="img/FriendsPlus/page29/E3/error-image.png" alt="image" width="30px" style='display: none;'/>
          </div>
        </div>


        <div id="drag" style="position: absolute; top: -5px; left: 606px;">
          <img
          src="/img/FriendsPlus/Page26/E2/3.png"
            alt=""
            width="130px"
          height="131px"
          />
          <div style="position: absolute;left: 70px;top:64px;">
            <img id='tick-image' src="img/FriendsPlus/page29/E3/tick-image.png" alt="image" width="40px" style='display: none;'/>
            <img id='error-image' src="img/FriendsPlus/page29/E3/error-image.png" alt="image" width="30px" style='display: none;'/>
          </div>
        </div>

        <div id="drag" style="position: absolute; top: -10px; left: 208px;">
          <img
          src="/img/FriendsPlus/Page26/E2/4.png"
            alt=""
            width="170px"
            height="135px"
          />
          <div style="position: absolute;left: 40px;top:65px;">
            <img id='tick-image' src="img/FriendsPlus/page29/E3/tick-image.png" alt="image" width="40px" style='display: none;'/>
            <img id='error-image' src="img/FriendsPlus/page29/E3/error-image.png" alt="image" width="30px" style='display: none;'/>
          </div>
        </div>

        <div id="drag" style="position: absolute; top: -5px; left: 750px;">
          <img
          src="/img/FriendsPlus/Page26/E2/5.png"
            alt=""
            width="150px"
            height="120px"
          />
          <div style="position: absolute;left: 72px;top:36px;">
            <img id='tick-image' src="img/FriendsPlus/page29/E3/tick-image.png" alt="image" width="40px" style='display: none;'/>
            <img id='error-image' src="img/FriendsPlus/page29/E3/error-image.png" alt="image" width="30px" style='display: none;'/>
          </div>
        </div>

        <div id="drag" style="position: absolute; top: -5px; left: 902px;">
          <img
          src="/img/FriendsPlus/Page26/E2/6.png"
            alt=""
            width="200px"
            height="120px"
          />
          <div style="position: absolute;left: 115px;top:36px;">
            <img id='tick-image' src="img/FriendsPlus/page29/E3/tick-image.png" alt="image" width="40px" style='display: none;'/>
            <img id='error-image' src="img/FriendsPlus/page29/E3/error-image.png" alt="image" width="30px" style='display: none;'/>
          </div>
        </div>


        <div style="display: flex; align-items: center;width: 1140px;">
          <div style="border: 1px solid black;margin-top: 150px;text-align:center;flex:1;height:255px">
            <p style="border-bottom: 1.2px solid black;font-size: 25px;">góc nhọn</p>
          </div>

          <div style="border: 1px solid black;border-left: none; margin-top: 150px;text-align:center;flex:1;height:255px">
          <p style="border-bottom: 1.2px solid black;font-size: 25px;">góc tù</p>
          </div>

          <div style="border: 1px solid black;border-left: none;margin-top: 150px;text-align:center;flex:1;height:255px">
          <p style="border-bottom: 1.2px solid black;font-size: 25px;">góc bẹt</p>
          </div>
        </div>
        
        
        
			`,
        answer: [""],
      },
    ],
  },
  3: {
    unit: "Unit 1",
    id: "SB7-U1-P16-E3",
    audio: "Audios/Chude8.mp3",
    video: "",
    component: T6,
    // hiddenNewWords:true,
    autoPlay: true,
    hideBtnFooter: true,
    questions: [
      {
        title: `
        <div style='position:relative;width:20cm'>
          <div style='position:absolute;top:-190px;left:35px;'>
              <img src ='/img/FriendsPlus/Page23/Demo3/2.png' style='height:6cm'/>
             
              <div style='position:absolute;background:rgb(125 208 179);top:201px;left:-180px;text-align:center;border:15px solid;border-radius:30px;padding:10px 50px; color:white;font-weight:900;font-size:35px'>
              
                Bài 8
              </div>
          </div>
        </div>
          <div style='margin-top:170px;margin-left:70px;background:rgb(254 252 208);text-align:center;border:15px solid;width:20cm;border-radius:30px;padding:20px 50px; color:rgb(246 106 126);font-weight:bold;font-size:35px'>
             GÓC NHỌN, GÓC TÙ, GÓC BẸT
          </div>
              `,
        answer: [],
      },
    ],
  },
};

export default json;
